import $ from 'jquery';
import Em from 'ember';
export default Em.Mixin.create({
  getCurrentBlock(returnListItem) {
    let $anchorNode;
    let listBlockTypes = returnListItem ? ', li' : ', ol, ul';
    let $editor = this.get('$editor');
    if (!$editor) {
      return null;
    }
    let selection = this.get('uiSelection').getDomSelection();
    if ($editor.find('.block-is-current').length) {
      return $editor.find('.block-is-current');
    }
    if (selection) {
      // In some circumstances during initialization Firefox decides that
      // accessing properties on the current anchorNode is a security problem
      // and throws an exception.
      // Let's just catch and bail in those
      try {
        /* eslint-disable */
        selection.anchorNode.nodeType;
        /* eslint-enable */
      } catch (e) {
        return null;
      }
      $anchorNode = $(selection.anchorNode);
      if ($anchorNode.closest('.embercom-composer-editor').length) {
        if ($anchorNode.is('ol, ul')) {
          return listBlockTypes.indexOf('li') > -1 ? $anchorNode.children().eq(selection.anchorOffset) : $anchorNode;
        }
        return $anchorNode.closest(`p, pre, h1, h2, ic-block${listBlockTypes}`);
      }
    }
    return null;
  },
  getCurrentEntity() {
    let $anchorNode;
    let $entity;
    let selection = this.get('uiSelection').getDomSelection();
    if (selection && selection.focusNode === selection.anchorNode) {
      $anchorNode = $(selection.anchorNode);
      if (selection.type === 'Caret' && selection.anchorOffset === $anchorNode.text().length) {
        return null;
      }
      $entity = $anchorNode.parent('b, i, a, ic-attribute').first();
      if ($entity.length === 1) {
        return this.get('composerState').getEntityById($entity.data('id'));
      }
    }
    return null;
  },
  getBlockAboveCurrent() {
    let previous = this.getCurrentBlock().prev();
    return previous.length ? previous : null;
  },
  getBlockBelowCurrent() {
    let next = this.getCurrentBlock().next();
    return next.length ? next : null;
  },
  isBlockAMediaType($block) {
    return $block ? !$block.is('p, ol, ul') : false;
  },
  isCurrentBlockAnICBlock() {
    let currentBlock = this.getCurrentBlock();
    let selection = this.get('uiSelection').getDomSelection();
    return selection.anchorNode === selection.focusNode && currentBlock && currentBlock.length > 0 && currentBlock[0].tagName === 'IC-BLOCK';
  },
  // TODO: POB: These two methods should be removed and caret manipulation should be handled
  // in the BOM
  putCaretAtStartOfNextBlock() {
    let nextBlock = this.getBlockBelowCurrent();
    if (nextBlock) {
      this.get('uiSelection.domSelection').putCaretAtStart(this.getBlockBelowCurrent());
    }
    return nextBlock;
  },
  putCaretAtEndOfPreviousBlock() {
    let previousBlock = this.getBlockAboveCurrent();
    if (previousBlock) {
      this.get('uiSelection.domSelection').putCaretAtEnd(previousBlock);
    }
    return previousBlock;
  }
});